<template>
  <form>
    <div class="row">
      <div class="col-lg-12">
        <h4 class="card-title">{{$t('medium_grant.submit__2_submission_checklist')}}</h4>

        <div class="ml-4 mt-4">
          <base-checkbox name="submit.readGuidelines" v-validate="'required:true'" v-model="GrantForm.model.submit.readGuidelines">
            <span :class="{ 'text-danger': getError('submit.readGuidelines') }">{{$t('medium_grant.submit__2_read_guidelines')}}</span>
          </base-checkbox>
          <base-checkbox name="submit.checkedBiopamaAction" v-validate="'required:true'" v-model="GrantForm.model.submit.checkedBiopamaAction">
            <span :class="{ 'text-danger': getError('submit.checkedBiopamaAction') }">{{$t('medium_grant.submit__2_checked_biopama_action')}}</span>
          </base-checkbox>
          <base-checkbox name="submit.transmittedOnPaper" v-validate="'required:true'" v-model="GrantForm.model.submit.transmittedOnPaper">
            <span :class="{ 'text-danger': getError('submit.transmittedOnPaper') }">{{$t('medium_grant.submit__2_transmitted_on_paper')}}</span>
          </base-checkbox>
          <base-checkbox name="submit.completedDueDiligence" v-validate="'required:true'" v-model="GrantForm.model.submit.completedDueDiligence">
            <span :class="{ 'text-danger': getError('submit.completedDueDiligence') }">{{$t('medium_grant.submit__2_completed_due_diligence')}}</span>
          </base-checkbox>
          <base-checkbox name="submit.completedEsms" v-validate="'required:true'" v-model="GrantForm.model.submit.completedEsms">
            <span :class="{ 'text-danger': getError('submit.completedEsms') }">{{$t('medium_grant.submit__2_completed_due_esms')}}</span>
          </base-checkbox>
          <base-checkbox name="submit.providedActualStart" v-validate="'required:true'" v-model="GrantForm.model.submit.providedActualStart">
            <span :class="{ 'text-danger': getError('submit.providedActualStart') }">{{$t('medium_grant.submit__2_provided_actual_start')}}</span>
          </base-checkbox>
          <base-checkbox name="submit.completedLogicalFramework" v-validate="'required:true'" v-model="GrantForm.model.submit.completedLogicalFramework">
            <span :class="{ 'text-danger': getError('submit.completedLogicalFramework') }">{{$t('medium_grant.submit__2_completed_logical_framework')}}</span>
          </base-checkbox>
          <base-checkbox name="submit.uploadedProjectBudget" v-validate="'required:true'" v-model="GrantForm.model.submit.uploadedProjectBudget">
            <span :class="{ 'text-danger': getError('submit.uploadedProjectBudget') }">{{$t('medium_grant.submit__2_uploaded_project_budget')}}</span>
          </base-checkbox>
          <base-checkbox name="submit.checkedBudgetIsComplete" v-validate="'required:true'" v-model="GrantForm.model.submit.checkedBudgetIsComplete">
            <span :class="{ 'text-danger': getError('submit.checkedBudgetIsComplete') }">{{$t('medium_grant.submit__2_checked_budget_is_complete')}}</span>
          </base-checkbox>
          <base-checkbox name="submit.budgetIsInBalance" v-validate="'required:true'" v-model="GrantForm.model.submit.budgetIsInBalance">
            <span :class="{ 'text-danger': getError('submit.budgetIsInBalance') }">{{$t('medium_grant.submit__2_budget_is_in_balance')}}</span>
          </base-checkbox>
          <base-checkbox name="submit.declarationBeenSigned" v-validate="'required:true'" v-model="GrantForm.model.submit.declarationBeenSigned">
            <span :class="{ 'text-danger': getError('submit.declarationBeenSigned') }">{{$t('medium_grant.submit__2_declaration_been_signet')}}</span>
          </base-checkbox>
          <base-checkbox name="submit.includedOnePageCv" v-validate="'required:true'" v-model="GrantForm.model.submit.includedOnePageCv">
            <span :class="{ 'text-danger': getError('submit.includedOnePageCv') }">{{$t('medium_grant.submit__2_included_one_page_cv')}}</span>
          </base-checkbox>
          <base-checkbox name="submit.includedCopyOfStakeHolders" v-validate="'required:true'" v-model="GrantForm.model.submit.includedCopyOfStakeHolders">
            <span :class="{ 'text-danger': getError('submit.includedCopyOfStakeHolders') }">{{$t('medium_grant.submit__2_included_copy_of_stakeholders')}}</span>
          </base-checkbox>
          <base-checkbox name="submit.includedCopyOfOrgStatus" v-validate="'required:true'" v-model="GrantForm.model.submit.includedCopyOfOrgStatus">
            <span :class="{ 'text-danger': getError('submit.includedCopyOfOrgStatus') }">{{$t('medium_grant.submit__2_included_copy_of_org_status')}}</span>
          </base-checkbox>
          <base-checkbox name="submit.includedOrgActivity" v-validate="'required:true'" v-model="GrantForm.model.submit.includedOrgActivity">
            <span :class="{ 'text-danger': getError('submit.includedOrgActivity') }">{{$t('medium_grant.submit__2_included_org_activity')}}</span>
          </base-checkbox>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <p class="mt-5">{{$t('general.disclaimer_application_submit')}}</p>
      </div>
    </div>
  </form>
</template>
<script>
  import {GrantForm} from "@/services";
  import swal from 'sweetalert2';

  export default {
    data() {
      return {
        GrantForm
      }
    },
    methods: {
      getError(fieldName) {
        return this.errors.first(fieldName);
      },
      showErrorNotification() {
        swal({
          title: this.$t('general.notification__warning'),
          html: this.$t('general.notification__checkboxes_mandatory').split("\n").join("<br>"),
          buttonsStyling: false,
          confirmButtonClass: 'btn btn-primary btn-fill',
          type: 'warning'
        });
      },
      async validate() {
        let validationResult = await this.$validator.validateAll();

        if (!validationResult) {
          this.showErrorNotification();
          return validationResult;
        }

        this.$emit('on-validated', validationResult, this.model);
        return validationResult;
      }
    }
  }
</script>